import * as React from 'react';

class TooltipTemplate extends React.Component {

    render() {
        return (
            <p className="tooltip-p-txt">{this.props.title}</p>
       
          )
    }
}

export default TooltipTemplate;